<template>
  <full-container>
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form ref="ff" size="small" :inline="true" :model="queryParams" class="search-form">
        <el-form-item>
          <el-date-picker v-model="queryParams.dealtime" type="monthrange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" />
        </el-form-item>
        <el-form-item>
          <categoryPicker :current.sync="queryParams.category" style="width: 120px" />
        </el-form-item>
        <el-form-item>
          <el-button @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <regionChart ref="chart" :params="queryParams" style="height: 100%" />
  </full-container>
</template>

<script>
export default {
  components: {
    regionChart: () => import('./charts/_region.vue'),
    categoryPicker: () => import("./auth/_categories.vue"),
  },
  data () {
    return {
      datalist: {},
      queryParams: {}
    }
  },
  methods: {
    onSearch () {
      this.$refs['chart'].queryParams = this.queryParams
      this.$refs['chart'].loadData()
    }
  }
}
</script>
